import React from 'react';

import {
  ScrollFadeContent,
  ScrollFadeViewport,
} from '@/shared/components/ui/scroll-fade/scroll-fade.styled';
import { TScrollFadeProps } from '@/shared/components/ui/scroll-fade/scroll-fade.types';
import { useScrollFade } from '@/shared/components/ui/scroll-fade/use-scroll-fade/use-scroll-fade';

export const ScrollFade: React.FC<TScrollFadeProps> = ({
  children,
  maxHeight,
  gap = '0',
  className,
}) => {
  const { ref, fadeStart, fadeEnd } = useScrollFade();

  return (
    <ScrollFadeViewport
      ref={ref}
      className={className}
      $maxHeight={maxHeight}
      $fadeStart={fadeStart}
      $fadeEnd={fadeEnd}
    >
      <ScrollFadeContent $gap={gap}>{children}</ScrollFadeContent>
    </ScrollFadeViewport>
  );
};
